export default function(){
  return {
    activeHistory:[],
    index:-1
  }
}
